// Client Portal — small shared pure utilities (HTML/CSS/URL sanitizers).

export const htmlEncode = (s) =>
  String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const safeCssColor = (val) =>
  /^#[0-9a-fA-F]{3,8}$/.test(val) ? val : "#000000";

export const isAllowedWebhookUrl = (url) => {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "https:";
  } catch {
    return false;
  }
};
